import * as jwt from "jwt-decode"

export function trimLeadingZeroes(str){
  if(typeof str === 'undefined' || str === null){
    return '';
  }
  return str.replace(/^0+/, '')
}

export function getInvoiceKey(invoice){
  return invoice.billing_document_number + '__' + invoice.document_number_finance;
}

export function isStringNotEmptyOrNull(val: string) {
    return typeof val !== "undefined" && val !== null && val !== "";
}
